import React from 'react';
import { Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

const TUTORIAL_IMAGE_PT = 'https://customer-assets-4nw71qhi.emergentagent.net/job_32530e50-a027-457d-afe0-fc3f5d7ca2a7/artifacts/a581ulde_dicas%20em%20portugues.png';
const TUTORIAL_IMAGE_EN = 'https://customer-assets-4nw71qhi.emergentagent.net/job_32530e50-a027-457d-afe0-fc3f5d7ca2a7/artifacts/il2jphsr_DICAS%20EM%20INGLES.png';

const ScopeRow = ({ label, value, testId }) => (
  <div className="flex items-center justify-between rounded-lg border border-white/10 bg-black/20 px-3 py-2" data-testid={testId}>
    <span className="text-sm text-white/70">{label}</span>
    <span className={`text-xs font-bold tracking-wide ${value === 'READ' ? 'text-[#00E676]' : 'text-white/40'}`}>{value}</span>
  </div>
);

export const DeribitApiTutorialModal = ({ open, onOpenChange }) => {
  const { t, isPortuguese } = useOptionsLocale();
  const tutorialImage = isPortuguese ? TUTORIAL_IMAGE_PT : TUTORIAL_IMAGE_EN;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] w-[min(94vw,760px)] max-w-[760px] overflow-y-auto border-white/10 bg-[#0A0A0A] text-white" data-testid="deribit-api-tutorial-modal">
        <DialogHeader>
          <DialogTitle className="text-xl font-black tracking-tight text-white" data-testid="deribit-api-tutorial-title">{t('deribitTutorial.modalTitle')}</DialogTitle>
          <DialogDescription className="text-sm text-white/60" data-testid="deribit-api-tutorial-subtitle">{t('deribitTutorial.modalSubtitle')}</DialogDescription>
        </DialogHeader>

        <div className="space-y-5">
          <img
            src={tutorialImage}
            alt={t('deribitTutorial.modalTitle')}
            className="w-full rounded-xl border border-white/10"
            data-testid="deribit-api-tutorial-image"
          />

          <div className="rounded-2xl border border-[#00E676]/20 bg-[#00E676]/[0.05] p-4" data-testid="deribit-api-tutorial-security-block">
            <div className="flex items-center gap-2 text-[#00E676]">
              <Lock size={16} />
              <p className="text-sm font-bold" data-testid="deribit-api-tutorial-security-title">{t('deribitTutorial.securityBadgeTitle')}</p>
            </div>
            <p className="mt-2 text-sm text-white/65" data-testid="deribit-api-tutorial-security-intro">{t('deribitTutorial.securityIntro')}</p>

            <div className="mt-4 grid gap-2 sm:grid-cols-2">
              <ScopeRow label={t('deribitTutorial.scopeAccountLabel')} value={t('deribitTutorial.scopeReadValue')} testId="deribit-api-tutorial-scope-account" />
              <ScopeRow label={t('deribitTutorial.scopeTradeLabel')} value={t('deribitTutorial.scopeReadValue')} testId="deribit-api-tutorial-scope-trade" />
              <ScopeRow label={t('deribitTutorial.scopeWalletLabel')} value={t('deribitTutorial.scopeReadValue')} testId="deribit-api-tutorial-scope-wallet" />
              <ScopeRow label={t('deribitTutorial.scopeBlockTradeLabel')} value={t('deribitTutorial.scopeNoneValue')} testId="deribit-api-tutorial-scope-block-trade" />
              <ScopeRow label={t('deribitTutorial.scopeBlockRfqLabel')} value={t('deribitTutorial.scopeNoneValue')} testId="deribit-api-tutorial-scope-block-rfq" />
              <ScopeRow label={t('deribitTutorial.scopeCustodyLabel')} value={t('deribitTutorial.scopeNoneValue')} testId="deribit-api-tutorial-scope-custody" />
            </div>

            <p className="mt-4 text-xs text-white/50" data-testid="deribit-api-tutorial-reject-note">{t('deribitTutorial.rejectExcessNote')}</p>
            <p className="mt-1 text-xs font-semibold text-white/70" data-testid="deribit-api-tutorial-cannot-trade-note">{t('deribitTutorial.cannotTradeNote')}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeribitApiTutorialModal;
